import React, { Component } from 'react';
import _ from 'lodash';
import { WithStyles, createStyles } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import { Grid, Card, CardContent, Typography } from '@material-ui/core';
import classNames from 'classnames';
import { MyPATDialog, SearchField, MyPATSelect, MyPATTextField, MyPATTextArea } from '../../common';
import data from '../__mocks__/courses.json'

// import Selects from '../courseForm/select_multiple_goals'
// import DateSelect from '../courseForm/date_select'
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import {styles} from '../styling/component/SelectMilestoneModal'


interface SelectMilestoneModalProp extends WithStyles<typeof styles> {
	selectMilestone: Boolean,
	closeSelectMilestone: Function,
	openSelectedMilestone:Function
}

interface SelectMilestoneModalState {
	selectedMilestone: string
}

class SelectMilestoneModal extends Component<SelectMilestoneModalProp, SelectMilestoneModalState> {
	constructor(props: SelectMilestoneModalProp) {
		super(props);
		this.selectMilestone = this.selectMilestone.bind(this)
		this.handleContinue=this.handleContinue.bind(this)
		this.state = ({
			selectedMilestone: ""
		})
	};

	selectMilestone(flag: string) {
		this.setState({
			selectedMilestone: flag
		})
	}

	handleContinue(event:any){
		event.preventDefault()
		this.props.openSelectedMilestone(this.state.selectedMilestone)
	}

	render() {
		const { classes, selectMilestone, closeSelectMilestone } = this.props;
		const { selectedMilestone } = this.state
		const otherDialogProps = {
			fullWidth: true,
			maxWidth: 'md',
			scroll: 'body',
		};
		return (
			<>
				<MyPATDialog
					dialogHeading={<Typography className={classes.headerLeft}>Select Milestone Type</Typography>}
					dialogOpen={selectMilestone}
					otherDialogProps={otherDialogProps}
					dialogHasActions={false}
					onDialogClose={closeSelectMilestone}
				>
					<form noValidate>
						<Grid container>
							<Grid container align-items-xs-center>

								<Grid item xs={4} onClick={() => this.selectMilestone("progressMilestone")}>
									<img className={selectedMilestone == "progressMilestone" ? classes.tickIcon : classes.tickIconHide} src="/assets/img/course/tick.png" alt="Milestone" />
									<img className={selectedMilestone == "progressMilestone" ? classes.borderSelected : ""} src="/assets/img/course/progressmilestone.png" alt="Milestone" />
								</Grid>
								<Grid item xs={4} onClick={() => this.selectMilestone("subMilestone")}>
									<img className={selectedMilestone == "subMilestone" ? classes.tickIcon : classes.tickIconHide} src="/assets/img/course/tick.png" alt="Milestone" />
									<img className={selectedMilestone == "subMilestone" ? classes.borderSelected : ""} src="/assets/img/course/submilestone.png" alt="Milestone" />
								</Grid>

								<Grid item xs={4} onClick={() => this.selectMilestone("reviewMilestone")}>
									<img className={selectedMilestone == "reviewMilestone" ? classes.tickIcon : classes.tickIconHide} src="/assets/img/course/tick.png" alt="Milestone" />
									<img className={selectedMilestone == "reviewMilestone" ? classes.borderSelected : ""} src="/assets/img/course/revisionmilestone.png" alt="Milestone" />
								</Grid>
							</Grid>

							<div style={{ fontSize: "16px", fontColor: "#333333", marginTop: "45px" }}>
								<span style={{ fontWeight: 600 }}>Progress Milestone:</span> Covers syllabus i.e. number of chapters
							</div>
							<div style={{ fontSize: "16px", fontColor: "#333333", marginTop: "15px" }}>
								<span style={{ fontWeight: 600 }}>Sub - Milestone:</span> Smaller milestones inside the milestone which can be like monthly tests, weekly tests, monday tests etc
							</div>
							<div style={{ fontSize: "16px", fontColor: "#333333", marginTop: "15px" }}>
								<span style={{ fontWeight: 600 }}>Revision Milestone:</span> Which has no syllabus to cover but has tests based on previous milestones or their combination
							</div>
						</Grid>
						<Grid xs={12} container justify="flex-end" alignItems="flex-end" className={selectedMilestone==""?classes.hideButton:""}>
								<Button
									variant="contained"
									type="submit"
									color="primary"
									onClick = {this.handleContinue}
									style={{ margin: "30px" }}
								>
									Continue
								</Button>
						</Grid>

						<br />
						<br />
					</form>
				</MyPATDialog>
			</>

		)
	}
};

// @ts-ignore
export default withStyles(styles)(SelectMilestoneModal);